import { render } from "./Men.vue?vue&type=template&id=9a76fae2"
import script from "./Men.vue?vue&type=script&lang=js"
export * from "./Men.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__